// extracted by mini-css-extract-plugin
export default {"newHeaderWrapper":"_wliv3v","overrideBackground":"_1pfow9b","apps-count":"_satnah","appsCount":"_satnah","mobileHeaderSpacing":"_1x9p7mn"};